export default __webpack_public_path__ + "static/perpetua-io-ogimage-JA-f8ddea5c1a6e595cc81df99bd832dde6.png";